import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import GetCurrentUserService from '../../user/Services/GetCurrentUserService.js'
import {HTTPTransactionRepository} from '../Repositories/HTTPTransactionRepository.js'
import {CreateReservationTransactionsRequestValueObject} from '../ValueObjects/CreateReservationTransactionsRequestValueObject.js'

class CreateReservationTransactionsUseCase extends UseCase {
  #config
  #repository
  #getCurrentUserService

  static create({config}) {
    return new CreateReservationTransactionsUseCase({
      config,
      repository: HTTPTransactionRepository.create({config}),
      getCurrentUserService: GetCurrentUserService.create({config})
    })
  }

  constructor({config, repository, getCurrentUserService}) {
    super()
    this.#config = config
    this.#repository = repository
    this.#getCurrentUserService = getCurrentUserService
  }

  @tracer({metric: 'CreateReservationTransactionsUseCase#execute'})
  @AsyncInlineError()
  async execute({adId}) {
    const userEntity = await this.#getCurrentUserService.execute()
    const userId = userEntity ? await userEntity.getId() : null

    const createReservationRequestValueObject = CreateReservationTransactionsRequestValueObject.create({
      adId,
      buyerId: userId
    })

    const [error, reservationEntity] = await this.#repository.createReservation(createReservationRequestValueObject)

    if (error) return Promise.reject(error)

    return reservationEntity
  }
}

export const factory = CreateReservationTransactionsUseCase.create
